import { Button, Typography } from "@mui/material";
import { Clock05Icon } from "@/components/common/icons";
import { PRIMARY } from "@/config/mui/colorPalette";
import useMoxieMediaQuery from "@/hooks/misc/useMoxieMediaQuery";

type ClockedOutWorkShiftsTrackerProps = {
  showAdditionalInfo: boolean;
  handleClick: () => void;
  disabled?: boolean;
};

export default function ClockedOutWorkShiftsTracker({
  showAdditionalInfo,
  handleClick,
  disabled = false,
}: ClockedOutWorkShiftsTrackerProps) {
  const isMobile = useMoxieMediaQuery("ipad-ver", "down");

  return (
    <Button
      onClick={handleClick}
      disabled={disabled}
      sx={{
        gap: 1,
        minWidth: 0,
      }}
    >
      <Clock05Icon
        size={isMobile ? 24 : 20}
        color={PRIMARY}
        strokeWidth={1.5}
      />
      {showAdditionalInfo && (
        <Typography variant="buttonSmall" color={PRIMARY}>
          Clock in
        </Typography>
      )}
    </Button>
  );
}
